import React from 'react';
import type { BadgeProps } from '@makemydeal/dr-ui-bricks-types';
import { BadgeWrapper } from './badge.style';

const Badge: React.FC<BadgeProps> = ({ children, className = '', 'data-testid': dataTestId }) => {
    return (
        <BadgeWrapper className={`badge-wrapper ${className}`} data-testid={dataTestId}>
            {children}
        </BadgeWrapper>
    );
};

export default Badge;
